// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"5af9b7e7","916":"ee1771d7"}[chunkId] + ".chunk.js";
};